import { v4 as uuidv4 } from "uuid";
import { OOVenue } from "./oo-venue";
import { OOCanvasMenuItemTimeRange } from "./OOCanvasMenuItemTimeRange.entity";
import { OOTimeRangeTimes } from "./OOTimeRangeTimes.entity";

export class OOTimeRanges {
	key: string = uuidv4();
	venueKey: number;
	name: string;
	active: boolean;
	startDate: Date;
	endDate: Date;

	created: Date;
	modified: Date;
	isFromPos: boolean;
	message: string;

	OOVenue: OOVenue;

	OOTimeRangeTimes: OOTimeRangeTimes[];
	OOCanvasMenuItemTimeRange: OOCanvasMenuItemTimeRange[];

	public constructor(init?: Partial<OOTimeRanges>) {
		Object.assign(this, init);
		if (this.OOTimeRangeTimes && this.OOTimeRangeTimes.length > 0) {
			this.OOTimeRangeTimes.map((i) => new OOTimeRangeTimes(i));
		}
	}
}
